export type FooterLink = {
    key: string,
    url: string,
};
export type Environment = 'sifi_fk' | 'kareena' | 'fungalk';
export type Locale = 'en' | 'it' | 'de' | 'fr' | 'es';

export const CLIENT: Environment = process.env.VUE_APP_CLIENT as Environment;
export const DEFAULT_LANG: Locale = (process.env.VUE_APP_LANG ?? 'en') as Locale;
